<template>
<v-card>
    <v-card-text>
    <v-layout row wrap>
        <v-flex xs12 class="pa-2">
            <v-text-field label="Nom" v-model="item.doc_name"></v-text-field>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-select 
                :items="types" item-text="typ_name" item-value="typ_id" 
                v-model="item.doc_typ_id" label="Statut" >
            </v-select>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-select 
                :items="table" item-text="table_name" item-value="table_id" 
                v-model="item.doc_table_id" label="Association" disabled >
            </v-select>
        </v-flex>
        <v-flex xs12 class="pa-2">
            <v-text-field label="Description" v-model="item.doc_description"></v-text-field>
        </v-flex>
        <v-flex xs12 class="pa-2">
            <v-file-input @change="getFileDocument" ref="documentfile" v-model="item.obj_file" show-size label="Fichier"></v-file-input>
        </v-flex>
    </v-layout>
    </v-card-text>
    <v-divider light></v-divider>
    <v-card-actions>
        <v-menu v-if="item.doc_id > 0" v-model="optionMenu" offset-y transition="slide-x-transition" bottom right >
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" outlined class="ml-0 pa-0" style="min-width: 5px;" color="grey"><v-icon>mdi-dots-vertical</v-icon></v-btn>
            </template>
            <v-btn class="ma-0" color="error" @click.native="deleteDocument()" :disabled="saveProgress">
                <v-icon left>mdi-trash-can</v-icon>Supprimer
            </v-btn>
        </v-menu>
        <v-spacer></v-spacer>
        <v-btn rounded  
            color="success" 
            :loading="saveProgress" @click.native="saveDocument()" :disabled="saveProgress">
            Enregistrer
        </v-btn>
        <v-btn rounded outlined color="grey" @click="switchModal('modalDocument', 0)">
            Fermer
        </v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import { mapWritableState, mapActions } from 'pinia'
import { useTypeStore } from '@/stores/type'
import { useDocumentStore } from '@/stores/document'

export default {
    name: 'document-edit',
    props: ['xxxId', 'docId', 'docTable', 'docType', 'switchModal', 'withFile'],
    computed: {
        ...mapWritableState(useDocumentStore, { item: 'item' }),
    },
    data: function () {
        return {
            dateMenu: { date_start:false, date_end:false },
            saveProgress: false,         // Enregistrement en cours...
            states : [],
            types : [],
            table : [
                { table_name: 'Projet',              table_id: 'pro' },
                { table_name: 'Evenement',           table_id: 'eve' },
            ],
            optionMenu: false,
        }
    },
    mounted:function (){
        const typeStore = useTypeStore()
        let typeCode = this.docType || 'DOC'
        this.types = this.types.concat( typeStore.itemListByGroup[typeCode] || [] )
        if( this.docId !== undefined && this.docId > 0 ){
            this.fetchItem( this.docId ).then( () => {
                if( this.withFile != undefined ){
                    this.item.obj_file = this.withFile
                }
            })
        } else {
            this.RESET_ITEM()
            this.item.doc_id       = 0
            this.item.doc_typ_id   = this.types[0].typ_id
            this.item.doc_table_id = this.docTable
            this.item.doc_xxx_id   = this.xxxId
            this.item.doc_usr_id_created   = 1
            if( this.withFile != undefined ){
                this.item.obj_file = this.withFile
                this.getFileDocument(this.withFile)
            }
        }
    },
    methods: {
        ...mapActions(useDocumentStore, ['fetchItem', 'storeItem', 'storeItemWithFile', 'updateItem', 'RESET_ITEM']),
        saveDocument(){
            if( this.item.doc_id !== undefined && this.item.doc_id > 0 && !this.item.obj_file ){
                this.updateItem().then( () => {
                    this.$emit('update:docId', this.item.doc_id)
                    this.switchModal('modalDocument', 0, true)
                })
            } else {
                this.storeItemWithFile().then( () => {
                    this.$emit('update:docId', this.item.doc_id)
                    this.switchModal('modalDocument', 0, true)
                })
            }
        },
        cancelEdit(){
            console.log('fonction')
        },
        deleteDocument(){
            this.deleteDocumentDocument( () => {
                this.$emit('update:docId', this.item.doc_id)
                this.switchModal('modalDocument', 0, true)
            })
        },
        getFileDocument(file){
            if( this.item.doc_name.length == 0 ){
                let nameTab = file.name.split(".")
                this.item.doc_name = nameTab[0]
            }
            this.item.doc_filename = file.name
        },
    },
    components: { }
}
</script>